<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>회원 공간</p></li>
            <li><p>회원 게시판</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>회원 게시판</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="table_search">
            <div class="select">
              <select name="" id="" v-model="params.searchType">
                <option :value="1">제목</option>
                <option :value="2">내용</option>
                <option :value="3">제목+내용</option>
              </select>
            </div>
            <div class="search_wrap">
              <div class="input">
                <input
                  type="search"
                  placeholder="검색"
                  v-model="params.searchText"
                  @keyup.enter="fetchData(1)"
                />
              </div>
              <button class="btn" @click="fetchData(1)">검색</button>
            </div>
            <div class="posit right_top">
              <!--              <button class="btn bo">내가 등록한 글 보기</button>-->
              <div class="checkbox">
                <input
                  type="checkbox"
                  id="a"
                  :true-value="1"
                  :false-value="0"
                  v-model="params.isMine"
                />
                <label for="a"><span>내가 등록한 글 보기</span></label>
              </div>
            </div>
          </div>
          <div class="table hover">
            <!--'게시판: hover'-->
            <div class="row head">
              <div class="cell fix150"><p>번호</p></div>
              <div class="cell"><p>제목</p></div>
              <div class="cell fix150"><p>작성자</p></div>
              <div class="cell fix240"><p>등록일</p></div>
            </div>
            <div class="page_con" v-if="$Util.isEmpty(items)">
              <div class="empty_wrap">
                <div class="empty">
                  <span>내역이 존재하지 않습니다.</span>
                </div>
              </div>
            </div>
            <div class="row" v-for="(item, index) in items" :key="index">
              <div class="cell fix150">
                <p>{{ pageInfo.virtualNum - index }}</p>
              </div>
              <div class="cell">
                <p class="left">
                  <span
                    class="lock"
                    :class="{ on: item.board.isSecret === 2 }"
                  ></span>
                  <!--아래 영역 클릭하면 이동하도록 해주세요-->
                  <span class="board_ttl" @click="fnView(item)">{{
                    item.board.boardTitle
                  }}</span>
                  <span class="comment">{{ item.board.reviewCount }}</span>
                </p>
              </div>
              <div class="cell fix150">
                <p>{{ item.user.userId }}</p>
              </div>
              <div class="cell fix240">
                <p class="date">
                  {{ $moment(item.board.regDate).format('YYYY.MM.DD') }}
                </p>
              </div>
            </div>
          </div>
          <div class="table_under">
            <router-link tag="button" to="/space/board/write" class="btn"
              >글쓰기</router-link
            >
          </div>
          <pagination
            v-bind="pageInfo"
            v-model="pageInfo.page"
            @change="fetchData"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'space-board-index',
  description: '회원 게시판',
  data: function() {
    return {
      params: {
        page: 1,
        limit: 10,
        searchType: 1,
        searchText: '',
        isMine: 0
      },
      items: [],
      pageInfo: {}
    }
  },
  computed: {
    userData: function() {
      return this.$store.getters['user/getUserData']
    }
  },
  watch: {
    'params.isMine': function (val) {
      this.params.isMine = val
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function(page = 1) {
      this.params.page = page
      const res = await this.$SpaceSvc.getListBoxBoard(this.params)
      if (res.code === 1) {
        this.items = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
    fnView: function(item) {
      if(item.board.isSecret === 2) {
        if(this.userData.userNo !== item.user.userNo) {
          alert('비공개 게시글입니다.')
          return false
        }
      }
      this.$router.push({
        path: '/space/board/view',
        query: { boardNo: item.board.boardNo }
      })
    }
  }
}
</script>

<style scoped></style>
